import React from 'react';
//import './Education.css'; // Optional CSS for styling

const Education = () => {
    return (

        <div className="page-container">
            <br></br>
            <br></br>
            <br></br>
            <br></br>

            <h1>Stay Tuned for Education Content!</h1>
            
        </div>
    );
};

export default Education;

